import { render } from "./home.vue?vue&type=template&id=08bf93fa&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=08bf93fa&lang=scss"
import "./home.vue?vue&type=style&index=1&id=08bf93fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bf93fa"]])

export default __exports__